import React from "react"

import "./style.scss"

export const Card = (props: React.HTMLProps<HTMLDivElement>) => {
    const { id, className, children } = props

    return (
        <div data-testid={id} id={id} className={`crd ${className ? className : ""}`}>
            {children}
        </div>
    )
}
